"use client";

import {
  IRefreshToken,
  IToken,
} from "@/features/authentication/interfaces/IAuth";
import { IProfile } from "@/interfaces/IProfile";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export interface IProfileStore {
  profile: IProfile | null;
  setProfile: (_profile: IProfile | null) => void;
  clearProfile: () => void;
  token: IToken | null;
  setToken: (_token: IToken | null) => void;
  clearToken: () => void;
  refreshToken: IRefreshToken | null;
  setRefreshToken: (_refreshToken: IRefreshToken | null) => void;
  clearRefreshToken: () => void;
}

const useProfileStore = create<IProfileStore>()(
  devtools(
    persist(
      (set) => ({
        profile: null,
        setProfile: (_profile) => {
          set(
            () => ({
              profile: _profile || null,
            }),
            false,
            "ProfileStore/setProfile",
          );
        },
        clearProfile: () => {
          set(
            () => ({
              profile: null,
            }),
            false,
            "ProfileStore/clearProfile",
          );
        },

        // Token
        token: null,
        setToken: (_token) => {
          set(
            () => ({
              token: _token || null,
            }),
            false,
            "ProfileStore/setToken",
          );
        },
        clearToken: () => {
          set(
            () => ({
              token: null,
            }),
            false,
            "ProfileStore/clearToken",
          );
        },
        refreshToken: null,
        setRefreshToken: (_refreshToken) => {
          set(
            () => ({
              refreshToken: _refreshToken,
            }),
            false,
            "ProfileStore/setRefreshToken",
          );
        },
        clearRefreshToken: () => {
          set(
            () => ({
              refreshToken: null,
            }),
            false,
            "ProfileStore/clearRefreshToken",
          );
        },
      }),
      { name: "profile-store" },
    ),
  ),
);

export default useProfileStore;
